import React, { ChangeEvent, FC } from "react";
import { ModalProps } from "../../../../helpers/constants";
import Modal from "../../../../components/common/form/Modal";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import TextAreaField from "../../../../components/common/form/TextAreaField";


interface MarkFalsePositiveModalProps extends ModalProps {
    title: string;
    bodyMessage: string;
    onSubmit: any;
    cancelBtnTxt?: string;
    confirmBtnTxt?: string;
    isLoading: boolean;
    note?: any;
    setNote?: any;
}

const MarkFalsePositiveModal: FC<MarkFalsePositiveModalProps> = ({
    show,
    setShow,
    title = "",
    bodyMessage = "",
    onSubmit,
    cancelBtnTxt = "Cancel",
    confirmBtnTxt = "Confirm",
    isLoading = false,
    note = "",
    setNote = "",
}) => {


    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | {
        name: string;
        value: any
    } | ChangeEvent<HTMLTextAreaElement>) => {
        const { name, value } = "target" in e ? e.target : e;
        setNote(value)
    }

    return (
        <Modal
            title={title}
            show={show}
            setShow={setShow}
            className={"w-2/5 mx-2 bg-text-0 text-surface-0"}
            fields={
                <>
                    <h3 className="mb-5 text-base font-normal text-surface-0    ">{bodyMessage}</h3>

                    <TextAreaField
                        name={"verified"}
                        label="Note"
                        onChange={handleOnChange}
                        value={note || ""}
                        placeholder="Enter Note Body..."
                        hidelabel

                    />

                    <ButtonTray
                        buttons={[
                            {
                                buttonProps: {
                                    btnText: cancelBtnTxt,
                                    onClick: () => setShow(false),
                                    type: "close",
                                },
                                buttonType: "button"
                            },
                            {
                                buttonProps: {
                                    btnText: confirmBtnTxt,
                                    onClick: async (e: any) => {
                                        e.preventDefault()
                                        await onSubmit(e)
                                        setShow(false)
                                    },
                                    type: "submit",
                                    isLoading: isLoading,
                                },
                                buttonType: "button",

                            }
                        ]}
                        align={"end"}
                        gap={2}
                    />

                </>
            }
        />
    );
};

export default MarkFalsePositiveModal;
